import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AuthModule, CognitoConfigService, StorageService } from '@uoa/auth';
import { provideErrorPages } from '@uoa/error-pages';
import { defineCustomElements } from '@uoa/web-components/loader';

import { AppAuthDesktopConfig } from './app/auth.desktop.config';
import { environment } from './environments/environment';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { AppStorageService } from './app/core/services';
import { WallboardsModule } from './app/pages/wallboard/wallboards.module';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AuthModule,
      IonicModule.forRoot(),
      AppRoutingModule,
      WallboardsModule,
    ),
    provideZoneChangeDetection(),
    provideErrorPages(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: CognitoConfigService, useClass: AppAuthDesktopConfig },
    { provide: StorageService, useClass: AppStorageService },
  ],
}).catch((err) => console.log(err));

defineCustomElements();